import { useCallback, useContext } from "react";
import { NavigatorContext } from "../../../../context";

export const useProductBox = ({ product }) => {
  const { navigateTo } = useContext(NavigatorContext);

  const addToCart = useCallback(() => {
    console.log("addToCart", product);
  }, [product]);

  const openProductPage = useCallback(
    () => navigateTo({ route: "/product/" + product.slug }),
    [navigateTo, product]
  );
  return {
    openProductPage,
    addToCart,
  };
};
